export enum AysClinicType {
    PUBLIC = 'public',
    PRIVATE = 'private',
    NONPROFIT = 'nonprofit'
}

export const AYS_CLINIC_TYPE_DISPLAY_NAMES: Record<AysClinicType, string> = {
  [AysClinicType.PUBLIC]: 'Öffentlich',
  [AysClinicType.PRIVATE]: 'Privat',
  [AysClinicType.NONPROFIT]: 'Freigemeinnützig',
};
